import { onSnapshot, orderBy, query } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { Report } from '../../entities';
import { getUserReportCollection } from '../../infrastructures/firebase';
import { addErrorEventOnSentry } from '../../infrastructures/sentry';

export const useReports = (uid?: string) => {
  const [isFetching, setIsFetching] = useState(true);
  const [reports, setReports] = useState<Report[]>([]);

  useEffect(() => {
    if (!uid) {
      return;
    }
    const ref = getUserReportCollection(uid);
    const q = query(ref, orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());

        setReports(data);
        setIsFetching(false);
      },
      (error) => {
        addErrorEventOnSentry(error);
        setIsFetching(false);
      },
    );

    return unsubscribe;
  }, [uid]);

  return { isFetching, reports };
};
